import type {PageRouteConfig} from '@router';

import PromotionCenterInfo from 'modules/Services/PromotionCenter/Info/PromotionCenterInfo';

export function createPromotionCenterInfoRoute(): PageRouteConfig {
  return {
    element: <PromotionCenterInfo />,
    layout: {
      title: 'تخفیف',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      headerDataKey: 'promotionCenter',
      link: -1
    },
    initialHeaderData: {
      promotionCenter: {icon: '', iconTitle: '', action: null, title: ''}
    }
  };
}
